import { useState, useRef } from 'react';
import { pdfjs } from 'react-pdf';
import { Document, Page } from 'react-pdf';

import '../css/react-pdf/AnnotationLayer.css';
import '../css/react-pdf/TextLayer.css';
import useResize from '../hooks/useResize';
import useWindow from '../hooks/useWindow';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url
).toString();

const options = {
  cMapUrl: '/cmaps/',
  wasmUrl: '/wasm/',
};

const PdfViewer = ({ file }) => {
  const [page, setPage] = useState(null);
  const [current] = useState(1);
  const componentRed = useRef();
  const [width] = useState(window.innerWidth);

  function onDocumentLoadSuccess({ numPages }) {
    setPage(numPages);
  }

  return (
    <div ref={componentRed}>
      <Document
        file={file}
        onLoadSuccess={onDocumentLoadSuccess}
        on
        options={options}
      >
        {Array.from(new Array(page), (l, index) => (
          <Page
            key={`page_${index + 1}`}
            width={width - 140}
            pageNumber={current}
          />
        ))}
      </Document>
    </div>
  );
};

export default PdfViewer;
